<script lang="ts" setup>
import { ref } from "vue";

defineProps<{
  isActive?: boolean;
}>();

const card = ref<HTMLElement | null>(null);

const scrollToTop = () => {
  card.value?.classList.add("scroll-mt-20");

  card.value?.scrollIntoView({
    behavior: "smooth",
  });

  card.value?.classList.remove("scroll-mt-20");
};

defineExpose({ scrollToTop });
</script>

<template>
  <article
    ref="card"
    :class="
      isActive
        ? 'border-yellow-600 has-[*[data-card-hover=true]:hover]:border-yellow-300'
        : 'border-green-900 has-[*[data-card-hover=true]:hover]:border-green-600'
    "
    class="card group relative flex w-full flex-col border-b-2 border-t-2 bg-black/50 shadow transition-colors sm:border-l-2 sm:border-r-2"
  >
    <slot />
  </article>
</template>

<style scoped></style>
